import { Component } from "@theme/component";

/**
 * Metafield-based review stars web component
 *
 * Usage:
 * <pr-stars data-rating="4.6" data-count="128" data-is-block="true"></pr-stars>
 */
export class PrStars extends Component {
  static STAR_COUNT = 5;

  connectedCallback() {
    super.connectedCallback();

    let rating = parseFloat(this.dataset.rating) || 0;
    let count = parseInt(this.dataset.count, 10) || 0;
    // Fixed shorthand: checks for string "true" or presence of attribute
    let block = this.dataset.isBlock === "true";

    const forceShow = this.hasAttribute("data-test-ratings");

    if (forceShow) {
      rating = Math.round((Math.random() * (5 - 4) + 4) * 10) / 10;
      count = Math.floor(Math.random() * (500 - 10 + 1)) + 10;
    }

    const hasData = rating > 0 || count > 0;

    if (!hasData && !forceShow) {
      this.style.display = "none";
      return;
    }

    const isFallback = forceShow && !(parseFloat(this.dataset.rating) > 0);

    // Pass 'block' to the render method
    this.render(rating, count, isFallback, block);
  }

  /* ----------------------------
   * Rendering
   * ---------------------------- */
  // @ts-ignore
  render(rating, count, isFallback, block) {
    const stars = this.buildStars(rating).join("");
    const rounded = rating.toFixed(1);

    const ariaLabel =
      count > 0
        ? `Rated ${rounded} out of 5 stars based on ${count} reviews`
        : `Rated ${rounded} out of 5 stars`;

    this.innerHTML = `
      <div
        class="powerreviews-stars ${isFallback ? "is-fallback" : ""}"
        role="img"
        aria-label="${ariaLabel}"
      >
        ${stars}
        ${!block ? `<span class="count" aria-hidden="true">(${count})</span>` : ""}
        <span class="sr-only">${ariaLabel}</span>
      </div>
    `;
  }

  /* ----------------------------
   * Star builder
   * ---------------------------- */
  // @ts-ignore
  buildStars(rating) {
    const stars = [];
    let remaining = Math.max(0, Math.min(5, rating));

    for (let i = 0; i < PrStars.STAR_COUNT; i++) {
      let fill = 0;

      if (remaining >= 1) fill = 100;
      else if (remaining >= 0.75) fill = 75;
      else if (remaining >= 0.5) fill = 50;
      else if (remaining >= 0.25) fill = 25;

      stars.push(
        `<span class="pr-star is-${fill}-filled" aria-hidden="true"></span>`,
      );

      remaining -= 1;
    }

    return stars;
  }
}

if (!customElements.get("pr-stars")) {
  customElements.define("pr-stars", PrStars);
}
